"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Org/InfoTab/TranslationSection.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _relations = require('shared/selectors/user/relations');




var _translation = require('shared/selectors/translation');
var _Form = require('web/components/Form');
var _noticeBar = require('web/services/context/noticeBar');
var _hooks = require('web/services/hooks');







/* Settings › Organization › Translation. Admins only: non-admins don't see
 * it, and the server refuses their changes. Hidden while the server has
 * translation off (nothing could be translated). */
const TranslationSection = ({ orgKey }) => {
  const isAdmin = _hooks.useAppSelector.call(void 0, state => _relations.selectAmIAdminInOrg.call(void 0, state, orgKey))
  const settings = _hooks.useAppSelector.call(void 0, state => _translation.selectOrgTranslationSettings.call(void 0, state, orgKey))
  const [isSaving, setIsSaving] = _react.useState.call(void 0, false)
  const { showSuccessBar, showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )

  _react.useEffect.call(void 0, () => {
    if (!isAdmin) return
    _actions2.default.getOrgTranslationSettings({ OrgKey: orgKey })
      .catch(() => showWarningBar('Failed to load translation settings'))
  }, [isAdmin, orgKey, showWarningBar])

  const update = _react.useCallback.call(void 0, (key, value) => {
    if (!settings) return
    setIsSaving(true)
    _actions2.default.updateOrgTranslationSettings({ ...settings, OrgKey: orgKey, [key]: value })
      .then(() => showSuccessBar('Organization translation settings updated'))
      .catch(() => showWarningBar('Failed to update organization translation settings'))
      .finally(() => setIsSaving(false))
  }, [settings, orgKey, showSuccessBar, showWarningBar])

  const onEnabled = _react.useCallback.call(void 0, (v) => update('Enabled', v), [update])
  const onInbound = _react.useCallback.call(void 0, (v) => update('TranslateInbound', v), [update])
  const onOutbound = _react.useCallback.call(void 0, (v) => update('TranslateOutbound', v), [update])

  if (!isAdmin || !settings || !_translation.isTranslationServerEnabled.call(void 0, settings)) return null

  const nestedEnabled = _translation.areNestedTranslationTogglesEnabled.call(void 0, settings)

  return (
    _react2.default.createElement('section', { className: "settings--org-info--translation", 'aria-labelledby': "org-translation-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}
      , _react2.default.createElement('h3', { id: "org-translation-title", className: "settings--org-info--translation--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}, "Translation"

      )
      , _react2.default.createElement(_Form.Toggle, {
        className: "settings--org-info--translation--toggle",
        label: "Turn on translation"  ,
        hint: "Off stops all translation in this organization's chats."       ,
        isChecked: settings.Enabled,
        isDisabled: isSaving,
        onChange: onEnabled, __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}
      )
      , _react2.default.createElement('div', { className: "settings--org-info--translation--nested", __self: this, __source: {fileName: _jsxFileName, lineNumber: 67}}
        , _react2.default.createElement(_Form.Toggle, {
          className: "settings--org-info--translation--toggle",
          label: "Translate inbound messages"  ,
          hint: "Patient messages show in English, with the original one click away."          ,
          isChecked: settings.TranslateInbound,
          isDisabled: !nestedEnabled || isSaving,
          onChange: onInbound, __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}}
        )
        , _react2.default.createElement(_Form.Toggle, {
          className: "settings--org-info--translation--toggle",
          label: "Translate outbound messages"  ,
          hint: "Staff replies go out in the patient's language. Turn this off if your program must meet Section 1557's human-review rule for machine translation."                      ,
          isChecked: settings.TranslateOutbound,
          isDisabled: !nestedEnabled || isSaving,
          onChange: onOutbound, __self: this, __source: {fileName: _jsxFileName, lineNumber: 76}}
        )
      )
    )
  )
}

exports. default = _react.memo.call(void 0, TranslationSection)
